export default __webpack_public_path__ + "static/media/avatar-defaul-girls.578435f6.jpg";